import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../app/services/theme.service';
import { Title } from '@angular/platform-browser';
import { EnvironmentService } from '../app/services/enviroment.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  clientId = '';
  name = '';
  css_file_name = '';

  private environmentService = inject(EnvironmentService);

  constructor(
    private themeService: ThemeService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    // 訂閱 EnvironmentService，並利用動態環境設定更新頁面
    this.environmentService.environment$.subscribe(environment => {
      if (environment) {

        // 更新頁面的標題
        document.title = environment.title;

        // 更新 favicon
        let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
        if (!link) {
          link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = environment.favicon;

        // 更新 apple-touch-icon
        document.querySelectorAll('link[rel="apple-touch-icon"]').forEach(el => el.remove());
        const appleTouchIcon: HTMLLinkElement = document.createElement('link');
        appleTouchIcon.rel = 'apple-touch-icon';
        appleTouchIcon.setAttribute('sizes', '180x180');
        appleTouchIcon.href = environment.appleTouchIcon;
        document.head.appendChild(appleTouchIcon);

        // 更新組件內其他環境相關屬性
        this.clientId = environment.clientId;
        this.name = environment.companyname;
        this.css_file_name = environment.css_file_name;

        // 載入客戶的 Theme
        this.themeService.loadClientTheme(this.css_file_name);
        // 如需要也可使用 Title service 更新標題
        this.titleService.setTitle(this.name);

        // 根據環境變數決定是否載入線上客服
        if (environment.enableOnlineSupport == true) {
          // this.loadTawkToScript();
        }

        // 監聽視窗大小變化，動態控制 Tawk.to 顯示/隱藏
        // window.addEventListener('resize', () => {
        //   this.hideTawkOnMobile();
        // });

      }
    });
  }

  /**
   * 動態載入 Tawk.to 線上客服 script
   */
  private loadTawkToScript(): void {
    // 檢查是否已經載入過，避免重複載入
    if ((window as any).Tawk_API) {
      return;
    }

    // 初始化 Tawk_API
    (window as any).Tawk_API = (window as any).Tawk_API || {};
    (window as any).Tawk_LoadStart = new Date();

    // 設置 Tawk.to 載入完成後的回調，在手機版隱藏
    (window as any).Tawk_API.onLoad = () => {
      this.hideTawkOnMobile();
    };

    // 動態建立並載入 script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://embed.tawk.to/683e8842e7b265190b0ccdb4/1isq48hoc';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    // 定期檢查並隱藏手機版的 Tawk.to 元素
    setTimeout(() => this.hideTawkOnMobile(), 1000);
    setTimeout(() => this.hideTawkOnMobile(), 3000);
    setTimeout(() => this.hideTawkOnMobile(), 5000);
  }

  /**
   * 在手機版隱藏 Tawk.to 客服元素
   */
  private hideTawkOnMobile(): void {
    const isMobile = window.innerWidth < 992;

    // 找到所有可能的 Tawk.to 元素
    const tawkElements = [
      '#tawkchat-minified-container',
      '#tawkchat-minified-box',
      '#tawkchat-container',
      '#tawkchat-status-container',
      '.tawk-min-container',
      '.tawk-min-box',
      '.tawk-chat-panel',
      '.tawk-chat-embed',
      '.tawk-widget',
      '.tawk-card',
      '#tawk-chatContainer',
      'iframe[src*="tawk.to"]',
      'iframe[title*="chat"]',
      'iframe[title*="Chat"]',
      'iframe[id*="tawk"]',
      'div[id*="tawk"]',
      'div[class*="tawk"]',
      '[data-tawk]',
      '[data-tawk-id]'
    ];

    tawkElements.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (isMobile) {
          // 手機版：隱藏
          (element as HTMLElement).style.display = 'none';
          (element as HTMLElement).style.visibility = 'hidden';
          (element as HTMLElement).style.opacity = '0';
        } else {
          // 桌面版：顯示
          (element as HTMLElement).style.display = '';
          (element as HTMLElement).style.visibility = '';
          (element as HTMLElement).style.opacity = '';
        }
      });
    });
  }
}
